import { Component, OnInit } from '@angular/core';
import { BaseDynamicFormComponent } from 'src/app/common/components/dynamic-form-v2/components/base-dynamic-form/base-dynamic-form.component';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { DynamicInputType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicInputType';
import { InputFieldType } from 'src/app/common/components/dynamic-form-v2/enums/InputFieldType';
import DynamicOptionsObject from 'src/app/common/components/dynamic-form-v2/dtos/DynamicOptionsObjectDTO';
import { BuildType } from 'src/app/enums/build-type';

@Component({
  selector: 'app-dynamic-mystery-box-form',
  templateUrl: './dynamic-mystery-box-form.component.html',
  styleUrls: ['./dynamic-mystery-box-form.component.sass']
})
export class DynamicMysteryBoxFormComponent extends BaseDynamicFormComponent implements OnInit {

  dynamicMysteryBoxRecord: any = {};
  
  constructor() {
    super();
  }

  ngOnInit() {
    this.fields = [
      {
        title: "Dynamic Mystery Box Data",
        fields: [
          {
            name: "Name",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.TextInput],
            clearField: true,
            key: 'name',
            isRequired: true,
            label: 'Name',
            columnWidth: 6
          },
          {
            name: "Display Name",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.TextInput],
            clearField: true,
            key: 'displayName',
            isRequired: true,
            label: 'Display Name',
            columnWidth: 6
          },
          {
            name: "Tier",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.Dropdown],
            clearField: true,
            key: 'tier',
            isRequired: true,
            label: 'Tier',
            columnWidth: 6,
            options: {
              fieldName: 'tier',
              values: [
                { label: 'Bronze', value: 1 },
                { label: 'Silver', value: 2 },
                { label: 'Gold', value: 3 }
              ]
            } as DynamicOptionsObject,
            optionValue: 'value',
            optionLabel: 'label'
          },
          {
            name: "Store Listing",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.AutoComplete],
            clearField: true,
            key: 'storeListing',
            isRequired: false,
            label: 'Store Listing',
            columnWidth: 6,
            autocompleteMultipleValues: false,
            autocompleteShowEmptyMessage: true,
            autocompleteField: 'name',
            autocompleteMinLength: 0,
            suggestions: {
              fieldName: 'storeListing',
              apiController: 'store-listings-v2',
              autopopulate: true,
              minimal: false,
              virtuals: false,
              customQueryField: 'name,id',
              select: '_id name id',
              isdisplayNameIDPath: false
            },
            style: { width: '100%' },
            showClear: true
          },
          {
            name: "Start Date Time",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.Calendar],
            clearField: true,
            key: 'start',
            isRequired: false,
            label: 'Start Date Time',
            columnWidth: 6,
            calendarShowTime: true,
            calendarYearNavigatior: true,
            calendarYearRange: '2020:2030',
            calendarMonthNavigator: true,
            calendarSelectOtherMonths: true
          },
          {
            name: "End Date Time",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.Calendar],
            clearField: true,
            key: 'end',
            isRequired: false,
            label: 'End Date Time',
            columnWidth: 6,
            calendarShowTime: true,
            calendarYearNavigatior: true,
            calendarYearRange: '2020:2030',
            calendarMonthNavigator: true,
            calendarSelectOtherMonths: true
          },
          {
            name: "Expiration Date",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.Calendar],
            clearField: true,
            key: 'expirationDate',
            isRequired: false,
            label: 'Expiration Date',
            columnWidth: 6,
            calendarYearNavigatior: true,
            calendarYearRange: '2020:2030',
            calendarMonthNavigator: true,
            calendarSelectOtherMonths: true
          },
          {
            name: "Description",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.InputTextArea],
            clearField: true,
            key: 'description',
            isRequired: false,
            label: 'Description',
            columnWidth: 6
          },
          {
            name: "Internal Notes",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.InputTextArea],
            clearField: true,
            key: 'internalNotes',
            isRequired: false,
            label: 'Internal Notes',
            columnWidth: 12
          },
          {
            name: "Content",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.AutoComplete],
            clearField: true,
            key: 'content',
            label: 'Content',
            columnWidth: 12,
            autocompleteMultipleValues: true,
            autocompleteShowEmptyMessage: true,
            autocompleteField: 'name',
            autocompleteMinLength: 2,
            suggestions: {
              fieldName: 'content',
              apiController: 'mystery-box-content',
              autopopulate: true,
              minimal: false,
              virtuals: false,
              customQueryField: 'name,id',
              select: '_id name id',
              isdisplayNameIDPath: false
            },
            style: { width: '100%' },
            showClear: true
          },
          {
            name: "Close State",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.AutoComplete],
            clearField: true,
            key: 'closeState',
            label: 'Close State',
            columnWidth: 6,
            autocompleteMultipleValues: false,
            autocompleteShowEmptyMessage: true,
            autocompleteField: 'name',
            autocompleteMinLength: 0,
            dropdown: true,
            suggestions: {
              fieldName: 'closeState',
              apiController: 'miscellaneous-build',
              autopopulate: true,
              minimal: false,
              virtuals: false,
              select: '_id name id path',
              customQuery: { entityType: { $in: [BuildType.Images] } },
              isdisplayNameIDPath: true,
              isMiscAsset: true
            },
            style: { width: '100%' },
            showClear: true
          },
          {
            name: "Close State Outlined",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.AutoComplete],
            clearField: true,
            key: 'closeStateOutlined',
            label: 'Close State Outlined',
            columnWidth: 6,
            autocompleteMultipleValues: false,
            autocompleteShowEmptyMessage: true,
            autocompleteField: 'name',
            autocompleteMinLength: 0,
            dropdown: true,
            suggestions: {
              fieldName: 'closeStateOutlined',
              apiController: 'miscellaneous-build',
              autopopulate: true,
              minimal: false,
              virtuals: false,
              select: '_id name id path',
              customQuery: { entityType: { $in: [BuildType.Images] } },
              isdisplayNameIDPath: true,
              isMiscAsset: true
            },
            style: { width: '100%' },
            showClear: true
          },
          {
            name: "3D Asset",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.AutoComplete],
            clearField: true,
            key: 'asset3D',
            label: '3D Asset',
            columnWidth: 12,
            autocompleteMultipleValues: false,
            autocompleteShowEmptyMessage: true,
            autocompleteField: 'name',
            autocompleteMinLength: 0,
            dropdown: true,
            suggestions: {
              fieldName: 'asset3D',
              apiController: 'miscellaneous-build',
              autopopulate: true,
              minimal: false,
              virtuals: false,
              select: '_id name id path',
              customQuery: { entityType: { $in: [BuildType.Items] } },
              isdisplayNameIDPath: true,
              isMiscAsset: true
            },
            style: { width: '100%' },
            showClear: true
          },
          {
            name: "Display Drop Rates",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.InputSwitch],
            clearField: false,
            key: 'displayDropRates',
            isRequired: false,
            label: 'Display Drop Rates',
            columnWidth: 6
          },
          {
            name: "Info Button",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.InputSwitch],
            clearField: false,
            key: 'infoButton',
            isRequired: false,
            label: 'Info Button',
            columnWidth: 6
          },
          {
            name: "Guaranteed Rewards",
            inputType: DynamicInputType.Price,
            key: 'guaranteedRewards',
            label: 'Guaranteed Rewards',
            columnWidth: 12,
            options: { fieldName: '', version: 3 },
            priceExcludeResourceTypes: ['Titles', 'SeedPackBox', 'StoreListing', 'Nurture', 'DynamicMysteryBox'],
          }
        ],
        type: DynamicCardType.Card
      }
    ];
    this.title = "Dynamic Mystery Box Form";
    this.viewRoute = 'dynamic-mystery-box';
    this.isLoading = false;
  }
}

